import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {production_volume_report_template} from "../components/templates/production_volume_report_template";

import {header} from "./header";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {downloadCSV} from "../../vendor/valnet/valnet_jslib/vnHelpers/helper_functions";

declare var ko: any;
declare var page: any;

export class production_volume_report extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected productionVolumeReportTemplate: production_volume_report_template;
    protected pagination: pagination_template;
    protected timer;

    protected getModuleName(): string{

        return "production_volume_report";
    }

    buildContent(): Array<Element>{

        // create the article list
        this.productionVolumeReportTemplate = new production_volume_report_template("list", this.viewModel, this);
        this.template = this.productionVolumeReportTemplate;

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("Production Volume Report");

        return [this.productionVolumeReportTemplate.build()];
    }

    public fillPage() : void{

        this.productionVolumeReportTemplate.buildDatePickerCalendar();
        this.getListFormData();
    }


    public getListFormData(): void{

        if( "getListFormData" in this.XHRHdls ){
            this.XHRHdls["getListFormData"].cancelAndReset();
        }

        this.loadingIn(this.productionVolumeReportTemplate.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/productionVolumeReport/brand/' + this.getVnAppZone().app.params.idBrand + '/references';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdls['getListFormData'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getListFormData'].onReadyStateFunction = this.onListFormDataRequestReturn;
        this.XHRHdls['getListFormData'].execute();

    }

    protected onListFormDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);

                obj.productionVolumeReportTemplate.setIntentFilterItems(responseParsed.intents);
                obj.productionVolumeReportTemplate.setContentTypeFilterItems(responseParsed.contentTypes);
                obj.productionVolumeReportTemplate.setNetworkCategoryFilterItems(responseParsed.groupCategory);
                obj.productionVolumeReportTemplate.setPaymentCategoryFilterItems(responseParsed.postPaymentCategories);

                obj.updateViewModelFromPath();
                obj.getSearchPresetsListData();

                obj.filterList();
            });
       }
    }

    protected paginationOnPageClick(){

        this.filterList();
    }

    protected filterDateOnChange(){
        // on keywords filtering, always set the page back to 1.
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterDropdownOnChange(){
        // on keywords filtering, always set the page back to 1.

        console.log(' user types');
        this.viewModel.list.pagination.pageNumber(1);

        this.filterList();
    }


    protected filterMultipleSelectorOnChange(){

        console.log('multi choice...');
        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected articlesListReorder(){

        this.filterList();
    }

    protected filterSimpleOnChange(idElement){

        this.viewModel.list.pagination.pageNumber(1);
        this.filterList();
    }

    protected filterSimpleCancel(){
        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterList(){

        // LOADING : starts
        this.loadingIn(this.productionVolumeReportTemplate.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/productionVolumeReport/brand/' + this.getVnAppZone().app.params.idBrand + '/get/';

        let subViewModel = this.productionVolumeReportTemplate.getViewModelForRequest();
        this.timer = new Date().getTime();
        this.sendFilterCall(usrReq_url, subViewModel, this.onFilterRequestReturn, XMLHttpRequestHandler_requestType.GET, 'production_volume_report');
    }

    protected onFilterRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed);
                obj.loadingOut(obj.productionVolumeReportTemplate.builtTemplate.children.namedItem("list-results"));
            });
        }
    }

    protected updateList(responseParsed: any) {

        this.productionVolumeReportTemplate.setVolumes(responseParsed.data.data);

        let execTime = Math.round((new Date().getTime() - this.timer)/1000*100)/100;
        this.productionVolumeReportTemplate.setResultInfo(responseParsed.data.totalCount, responseParsed.data.totalPage, execTime );

        //Update the Paginator
        this.viewModel.list.pagination.itemCount(responseParsed.data.totalCount);
    }

    protected getMemoryViewModel(){

        let templateViewModel = this.productionVolumeReportTemplate.getTemplateViewModel();

        delete templateViewModel.articles;

        return templateViewModel;
    }

    protected getUsersSuggestion(keyword, idElement) {

        if( "getUsersSuggestion" in this.XHRHdls ){
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        let subViewModel = {list: {keyword: keyword}, idElement: idElement};

        //let subViewModel = {list: {keyword: keyword}};
        let usrReq_url: string = '/api/productionVolumeReport/brand/' + this.getVnAppZone().app.params.idBrand + "/search/user/";
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls['getUsersSuggestion'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getUsersSuggestion'].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls['getUsersSuggestion'].execute();
    }

    protected onGetUsersSuggestionsReturn(req, obj) {

        return function () {

            if (req.request.readyState == 4) {

                let response = JSON.parse(req.request.response);

                if (req.request.status == 200) {

                    obj.productionVolumeReportTemplate.setUserFilter(response);

                } else if (req.request.status == "423") {
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, response.message);
                    obj.getVnAppZone().showNotificationToModule();
                } else {
                    obj.productionVolumeReportTemplate.onUpdateError(req.request.status, response);
                }

                // LOADING : ends
                obj.productionVolumeReportTemplate.deactivateLoading();
            }
        }
    }

    protected saveSearchPreset(){

        if( "saveSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveSearchPreset"].cancelAndReset();
        }

        let formReq_url: string = '/api/search_preset/save';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(this.productionVolumeReportTemplate.getViewModelForRequest()));

        formReq_params.push(["data", ko.toJSON(subViewModel)] );

        this.XHRHdls['saveSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveSearchPreset'].onReadyStateFunction = this.onPostSearchPresetArticles
        this.XHRHdls['saveSearchPreset'].execute();
    }

    private onPostSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

                obj.productionVolumeReportTemplate.addCreatedPresetToList(response);

            });

        }
    }

    protected saveFavoriteSearchPreset( params: {presetId: number, searchPresetType: string}): void {

        if( "saveFavoriteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["saveFavoriteSearchPreset"].cancelAndReset();
        }
        let formReq_url: string = '/api/search_preset/favorite/save/';
        let formReq_params: Array<Array<string>> = [];

        let subViewModel = JSON.parse(ko.toJSON(params));

        formReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['saveFavoriteSearchPreset'] = new XMLHttpRequestHandler(formReq_url,formReq_params, this);

        this.XHRHdls['saveFavoriteSearchPreset'].mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdls['saveFavoriteSearchPreset'].onReadyStateFunction = this.onPostFavoriteSearchPresetArticles
        this.XHRHdls['saveFavoriteSearchPreset'].execute();
    }

    private onPostFavoriteSearchPresetArticles(req, obj): Function {
        return function () {
            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected deleteSearchPreset(presetId: number): void {

        if( "deleteSearchPreset" in this.XHRHdls ){
            this.XHRHdls["deleteSearchPreset"].cancelAndReset();
        }

        let usrReq_url: string = '/api/search_preset/delete/' + presetId + '/';
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdls['deleteSearchPreset'] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['deleteSearchPreset'].onReadyStateFunction = this.onDeleteSearchPresetReturn;
        this.XHRHdls['deleteSearchPreset'].execute();
    }

    protected onDeleteSearchPresetReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);

            });
        }
    }

    protected getSearchPresetsListData(): void {

        if( "getSearchPresetsListData" in this.XHRHdls ){
            this.XHRHdls["getSearchPresetsListData"].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON(this.productionVolumeReportTemplate.getViewModelForRequest()));
        let usrReq_url: string = '/api/search_preset/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);

        this.XHRHdls['getSearchPresetsListData']= new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls['getSearchPresetsListData'].onReadyStateFunction = this.onGetSearchPresetsReturn;
        this.XHRHdls['getSearchPresetsListData'].execute();
    }

    protected onGetSearchPresetsReturn(req, obj): Function {

        return () => {

            obj.manageResponse(req, obj, function () {
                let response = JSON.parse(req.request.response);
                obj.productionVolumeReportTemplate.setSearchPresets(response);
                obj.filterList();
            });
        }
    }

    protected setDefaultStatusFilters(){
        this.productionVolumeReportTemplate.setDefaults();
    }

    protected filterByUrl(){
        this.updateViewModelFromPath();
        this.filterList();
    }

    protected filterByPresets(filters){
        this.productionVolumeReportTemplate.setViewModelFromRequest(filters);
        this.filterList();
    }

    protected getExportData(){

        if( this.XHRHdl ){
            this.XHRHdl.cancelAndReset();
        }

        // LOADING : starts
        this.loadingIn(this.productionVolumeReportTemplate.builtTemplate.children.namedItem("list-results"));

        let subViewModel = this.productionVolumeReportTemplate.getViewModelForRequest();
        let subViewModelClone = Object.assign({}, subViewModel);
        subViewModelClone.pagination.pageNumber(1)
        subViewModelClone.pagination.itemPerPage = 100000;

        let usrReq_url: string = '/api/productionVolumeReport/brand/' + this.getVnAppZone().app.params.idBrand + '/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModelClone)] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetExportDataReturn;
        this.XHRHdl.execute();
    }

    protected onGetExportDataReturn(req, obj){

        return function(){

            if (req.request.readyState == 4) {

                let responseParsed = JSON.parse(req.request.response);

                if(  req.request.status == 200  ){
                    obj.exportToCSV(responseParsed.data.data);
                } else if( req.request.status == 423 ){
                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, responseParsed.message);
                    obj.getVnAppZone().showNotificationToModule();
                    page.redirect('/brand/' + obj.getVnAppZone().app.params.idBrand + '/home');
                }
                else{
                    obj.onUpdateError(req.request.status, responseParsed);
                }

                // LOADING : ends
                obj.loadingOut(obj.productionVolumeReportTemplate.builtTemplate.children.namedItem("list-results"));
            }
        }
    }

    public exportToCSV(data:any){

        downloadCSV({filename: "productionVolumeReport.csv", data: data});
    }
}


// WEBPACK FOOTER //
// ./js/modules/production_volume_report.ts